import { TAGS } from "@/store/api"
import { deckEndpoints } from "@/store/apis/deckAPI"
import { effectsApi } from "@/store/apis/effectsAPI"
import { gameplayEndpoints } from "@/store/apis/gameplayAPI"
import { matchEndpoints } from "@/store/apis/matchAPI"
import { playerEndpoints } from "@/store/apis/playerAPI"
import { AppDispatch } from "@/store/index"
import { clearGameplayState } from "@/store/slices/gameplay"
import { clearMatchState } from "@/store/slices/match"

export const invalidateAllGameStates = (dispatch?: AppDispatch) => {
  dispatch?.(clearMatchState())
  dispatch?.(clearGameplayState())
  dispatch?.(deckEndpoints.util.invalidateTags([{ type: TAGS.DECK }]))
  dispatch?.(effectsApi.util.invalidateTags([{ type: TAGS.EFFECTS }]))
  dispatch?.(matchEndpoints.util.invalidateTags([{ type: TAGS.MATCH }]))
  dispatch?.(playerEndpoints.util.invalidateTags([{ type: TAGS.PLAYER }]))
  dispatch?.(gameplayEndpoints.util.invalidateTags([{ type: TAGS.GAMEPLAY }]))
}
